import { COPYRIGHT_POLICY_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[COPYRIGHT_POLICY_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'copyrightPolicy',
	},
}
